import React, { useState, useEffect } from "react";
import {
  StyleSheet,
  Dimensions,
  View,
  Image,
  Pressable,
  Text,
} from "react-native";
import { whiteColor, blackColor, greenBold } from "./../../common/colors";

const CircleSlider = ({ question, sliderValue, onValueChange, value }) => {
  const checkValue = (v) => {
    switch (v) {
      case 0:
        return 1;
      case 16:
        return 2;
      case 32:
        return 3;
      case 66:
        return 5;
      case 82:
        return 6;
      case 100:
        return 7;
      default:
        return 4;
    }
  };
  const [state, setState] = useState(checkValue(sliderValue));

  useEffect(() => setState(checkValue(sliderValue)), [sliderValue]);

  const isSelected = (id, buttonStyle) => {
    const selected = id === 4 ? styles.selectedCenter : styles.selected;
    return state === id ? [buttonStyle, selected] : buttonStyle;
  };

  return (
    <View style={styles.container}>
      <Pressable
        onPress={() => {
          setState(1);
          onValueChange(0);
        }}
        style={isSelected(1, styles.button1)}
      >
        <Text> </Text>
      </Pressable>
      <Pressable
        onPress={() => {
          setState(2);
          onValueChange(16);
        }}
        style={isSelected(2, styles.button2)}
      >
        <Text> </Text>
      </Pressable>
      <Pressable
        onPress={() => {
          setState(3);
          onValueChange(32);
        }}
        style={isSelected(3, styles.button3)}
      >
        <Text> </Text>
      </Pressable>
      <Pressable style={styles.button4}>
        <Text> </Text>
      </Pressable>
      <Pressable
        onPress={() => {
          setState(5);
          onValueChange(66);
        }}
        style={isSelected(5, styles.button5)}
      >
        <Text> </Text>
      </Pressable>
      <Pressable
        onPress={() => {
          setState(6);
          onValueChange(82);
        }}
        style={isSelected(6, styles.button6)}
      >
        <Text> </Text>
      </Pressable>
      <Pressable
        onPress={() => {
          setState(7);
          onValueChange(100);
        }}
        style={isSelected(7, styles.button7)}
      >
        <Text> </Text>
      </Pressable>
    </View>
  );
};
export default CircleSlider;

const styles = StyleSheet.create({
  selected: {
    backgroundColor: "#3C3C3C",
  },
  selectedCenter: {
    backgroundColor: "#8B849B",
  },
  button1: {
    borderRadius: 100,
    width: 48,
    height: 48,
    borderWidth: 2,
    borderColor: "#3C3C3C",
  },
  button2: {
    borderRadius: 100,
    width: 41,
    height: 41,
    borderWidth: 2,
    borderColor: "#3C3C3C",
  },
  button3: {
    borderRadius: 100,
    width: 34,
    height: 34,
    borderWidth: 2,
    borderColor: "#3C3C3C",
  },
  button4: {
    borderRadius: 100,
    width: 28,
    height: 28,
    borderWidth: 2,
    borderColor: "#8B849B",
  },
  button5: {
    borderRadius: 100,
    width: 34,
    height: 34,
    borderWidth: 2,
    borderColor: "#3C3C3C",
  },
  button6: {
    borderRadius: 100,
    width: 41,
    height: 41,
    borderWidth: 2,
    borderColor: "#3C3C3C",
  },
  button7: {
    borderRadius: 100,
    width: 48,
    height: 48,
    borderWidth: 2,
    borderColor: "#3C3C3C",
  },
  container: {
    flexDirection: "row",
    flexWrap: "wrap-reverse",
    justifyContent: "space-around",
    alignItems: "center",
  },
});
